/**
 *
 * @Author      Susana Garcia Rodriguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
export const TABS_ACCESS = {
    ACCESS_USER: {
        INDEX: 0,
        TRANS: "user_access"
    },
    ACCESS_VEHICLE: {
        INDEX: 1,
        TRANS: "vehicle_access"
    },
};